"use client"

import { useEffect, useRef } from "react"
import { ProductFilterPanel, type ProductFilterPanelHandle } from "./product-filter-panel"
import type { ProductOption } from "@/types/shopify"

interface ProductFilterSideTabProps {
  integrationId: string
  dateRange: { month_start_utc: Date; month_end_utc: Date }
  minimumOrderTotal: number
  selectedProducts: Map<number, ProductOption>
  onSelectionChange: (products: Map<number, ProductOption>) => void
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function ProductFilterSideTab({
  integrationId,
  dateRange,
  minimumOrderTotal,
  selectedProducts,
  onSelectionChange,
  open,
  onOpenChange,
}: ProductFilterSideTabProps) {
  const panelRef = useRef<ProductFilterPanelHandle>(null)

  useEffect(() => {
    if (open) {
      // Small delay to let the slide animation start before focusing
      const timer = setTimeout(() => panelRef.current?.focusSearch(), 150)
      return () => clearTimeout(timer)
    }
  }, [open])

  return (
    // Fixed wrapper matches the main app container (max-w-[1920px] mx-auto)
    // so children are anchored to the container edge, not the viewport edge.
    <div id="product-filter-panel" className="pointer-events-none fixed inset-0 z-40 mx-auto max-w-[1920px] overflow-hidden">
      {/* Overlay panel — always mounted, slides in/out */}
      <div
        className={[
          "pointer-events-auto absolute inset-y-0 right-0 w-[360px] border-l shadow-xl transition-transform duration-300 ease-in-out",
          open ? "translate-x-0" : "translate-x-full",
        ].join(" ")}
      >
        <ProductFilterPanel
          ref={panelRef}
          integrationId={integrationId}
          dateRange={dateRange}
          minimumOrderTotal={minimumOrderTotal}
          selectedProducts={selectedProducts}
          onSelectionChange={onSelectionChange}
          onClose={() => onOpenChange(false)}
        />
      </div>
    </div>
  )
}
